import React, {useMemo} from 'react';


import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {
    LicenseAccessModuleDisableTool,
    LicenseAccessModuleEnableTool,
    UpdateAccountStatusTool,
    UpdateAccountTeamMemberTool,
} from 'src/modules/bulk-update';

import {useShown} from '@pb/kit-hooks-use-shown';

import {ToolsMenu} from './tools-menu';
import {ToolsRow} from './tools-row';

type Props = {
    ids: number[],
    onDone: () => void,
};

export const AccountsAdvancedSearchBulkActions = ({ids, onDone}: Props) => {
    const {hasAccess} = useAdminAccessRight();

    const {
        shown: addToAccountTeamShown,
        onClick: openAddToAccountTeamTool,
        onClose: closeAddToAccountTeamTool,
    } = useShown();

    const {
        shown: setAccountStatusShown,
        onClick: openSetAccountStatusTool,
        onClose: closeSetAccountStatusTool,
    } = useShown();

    const {
        shown: enableModuleAccessPermissionsToolShown,
        onClick: openEnableModuleAccessPermissionsTool,
        onClose: closeEnableModuleAccessPermissionsTool,
    } = useShown();

    const {
        shown: disableModuleAccessPermissionsToolShown,
        onClick: openDisableModuleAccessPermissionsTool,
        onClose: closeDisableModuleAccessPermissionsTool,
    } = useShown();

    const showAddToAccountTeam = useMemo(() => (
        hasAccess(ACCESS_RIGHTS.BULK_ACCOUNT_TEAM_MEMBER)
    ), [hasAccess]);

    const showUpdateAccountStatus = useMemo(() => (
        hasAccess(ACCESS_RIGHTS.BULK_ACCOUNT_STATUS_UPDATE)
    ), [hasAccess]);

    const showUpdateLicense = useMemo(() => (
        hasAccess(ACCESS_RIGHTS.BULK_LICENSE_UPDATE)
    ), [hasAccess]);

    const toolsCount = useMemo(() => [
        true,
        showAddToAccountTeam,
        showUpdateAccountStatus,
        showUpdateLicense,
    ].filter(Boolean).length, [showAddToAccountTeam, showUpdateAccountStatus, showUpdateLicense]);

    return (
        <>
            {toolsCount < 6 ? (
                <ToolsRow
                    accountIds={ids as Array<number>}

                    showAddToAccountTeam={showAddToAccountTeam}
                    openAddToAccountTeamTool={openAddToAccountTeamTool}

                    showSetAccountStatus={showUpdateAccountStatus}
                    openSetAccountStatusTool={openSetAccountStatusTool}

                    showUpdateLicense={showUpdateLicense}
                    openEnableModuleAccessPermissionsTool={openEnableModuleAccessPermissionsTool}
                    openDisableModuleAccessPermissionsTool={openDisableModuleAccessPermissionsTool}
                />
            ) : (
                <ToolsMenu
                    accountIds={ids as Array<number>}
                    showAddToAccountTeam={showAddToAccountTeam}
                    openAddToAccountTeamTool={openAddToAccountTeamTool}

                    showSetAccountStatus={showUpdateAccountStatus}
                    openSetAccountStatusTool={openSetAccountStatusTool}

                    showUpdateLicense={showUpdateLicense}
                    openEnableModuleAccessPermissionsTool={openEnableModuleAccessPermissionsTool}
                    openDisableModuleAccessPermissionsTool={openDisableModuleAccessPermissionsTool}
                />
            )}
            <UpdateAccountTeamMemberTool
                shown={addToAccountTeamShown}
                accountIds={ids}
                onDone={onDone}
                onClose={closeAddToAccountTeamTool}
            />
            <UpdateAccountStatusTool
                shown={setAccountStatusShown}
                accountIds={ids}
                onDone={onDone}
                onClose={closeSetAccountStatusTool}
            />
            <LicenseAccessModuleEnableTool
                shown={enableModuleAccessPermissionsToolShown}
                accountIds={ids}
                onDone={onDone}
                onClose={closeEnableModuleAccessPermissionsTool}
            />
            <LicenseAccessModuleDisableTool
                shown={disableModuleAccessPermissionsToolShown}
                accountIds={ids}
                onDone={onDone}
                onClose={closeDisableModuleAccessPermissionsTool}
            />
        </>
    );
};
